"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("../../utils");
/**
 * An object that contains valid times and dates represented by a map request.
 */
class MapMetadata {
  /**
   * Creates and returns a MapMetadata instance initialized with the specified headers.
   *
   * @param {(Headers | any)} headers
   * @memberof MapMetadata
   */
  constructor(headers) {
    let valid;
    let minValid;
    let maxValid;
    let run;
    if ((0, _utils.isObject)(headers)) {
      valid = headers['x-aeris-valid-date'];
      minValid = headers['x-aeris-min-valid-date'];
      maxValid = headers['x-aeris-max-valid-date'];
      run = headers['x-aeris-run-date'];
    }
    if (valid) {
      this.validDate = new Date(valid);
    }
    if (minValid) {
      this.minValidDate = new Date(minValid);
    }
    if (maxValid) {
      this.maxValidDate = new Date(maxValid);
    }
    if (run) {
      this.runDate = new Date(run);
    }
  }
}
var _default = exports.default = MapMetadata;
module.exports = exports.default;